export const ErrorType = {
    EnterFailed: 'Enter failed',
    ExitFailed: 'Exit failed',
    MountFailed: 'Mount failed',
    UnmountFailed: 'Unmount failed',
    LoadResourceFailed: 'Load resource failed'
};
